import store from '../../store';
import Config from '../../cankado-config';
import { SetVerifyModalWindow } from '../../actions/ui';

let ws = null;

export default function webSocket(uuid) {
    // Prevent duplicate connections
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
        return ws;
    }

    if (uuid) {
        const wsScheme = window.location.protocol === 'https:' ? 'wss' : 'ws';
        const wsApiRoot = Config.apiRoot.split('//').pop();

        ws = new WebSocket(`${wsScheme}://${wsApiRoot}/socket/${uuid}`);

        ws.onopen = () => {
            console.log('WebSocket connected');
        };

        ws.onmessage = (e) => {
            try {
                const message = JSON.parse(e.data);

                console.log(message, 'socket message received');

                const assid = store.getState().assessments.assUuid;

                if (message.action === 'VERIFIED') {
                    if (message.data.assessment_uuid === assid) {
                        store.dispatch(SetVerifyModalWindow('QR_CODE_SUCCESS'));
                    }
                }

                if (message.action === 'INVALID_VERIFICATION') {
                    if (message.data.assessment_uuid === assid) {
                        store.dispatch(SetVerifyModalWindow('QR_CODE_FAIL'));
                    }
                }
            } catch (err) {
                console.error('WebSocket message parse error', err);
            }
        };

        ws.onerror = (error) => {
            console.error('WebSocket error', error);
        };

        ws.onclose = (event) => {
            console.log('WebSocket closed', event);

            // cleanup
            ws = null;
        };
    }

    return ws;
}

export function wsClose() {
    if (ws) {
        // Remove handlers
        ws.onopen = null;
        ws.onmessage = null;
        ws.onerror = null;
        ws.onclose = null;

        // Close only if needed
        if (
            ws.readyState === WebSocket.OPEN ||
            ws.readyState === WebSocket.CONNECTING
        ) {
            ws.close();
        }

        ws = null;
    }
}